import { render, staticRenderFns, recyclableRender, components } from "./u-modal.vue?vue&type=template&id=713d0fd3&scoped=true&"
var renderjs
import script from "./u-modal.vue?vue&type=script&lang=js&"
export * from "./u-modal.vue?vue&type=script&lang=js&"
import style0 from "./u-modal.vue?vue&type=style&index=0&id=713d0fd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713d0fd3",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-modal/u-modal.vue"
export default component.exports